<div class="mb-3">
  @if (!hideLabel) {
    <label
      class="form-label"
      [attr.for]="inputId">
      {{ getLabel() }}
    </label>
  }
  <input
    #inputElement
    class="form-control"
    [attr.name]="boFieldPath"
    [autocomplete]="autocomplete"
    placeholder="{{ placeholder ?? getPlaceholder() }}"
    [attr.type]="fieldType"
    [formControl]="fieldControl"
    [ngClass]="getValidityClass()"
    [attr.id]="inputId"
    (input)="onInput()"
    (blur)="onBlur()" />
  <!-- Error feedback -->
  <bo-form-field-errors></bo-form-field-errors>
</div>
